import { Navigate, useLocation } from "react-router-dom"
import React, { useEffect } from "react";
import { instance,  ticketingInstance } from "../../../shared/utilites/ApiClient";

export default function Logout() {
    const location = useLocation();

    // Capture portal type BEFORE clearing localStorage (synchronously)
    const portalType = localStorage.getItem('portal_type');
    const isReportPortal = location.pathname.includes('/powerbi-portal') || portalType === 'report';
    const redirectPath = isReportPortal ? '/powerbi-portal/login' : '/login';

    // Clear localStorage and API headers
    useEffect(() => {
       localStorage.clear();
       delete instance.defaults.headers.common["x-api-token"];
       delete ticketingInstance.defaults.headers.common["x-api-token"];
     }, []);

    // Redirect to the appropriate login page based on portal type
    console.log("redirectPath", redirectPath)
    return <Navigate to={redirectPath} />
}